import {
  EntityWithRelatedEntitiesFragment,
  InsightEntityActivity,
  InsightEntityFragment,
  InsightEntityWithRelationsFragment,
  mockEntitiesDetailsQuery,
  mockEntityRelationshipsByIdsQuery,
} from '__generated__';
import { delay, http, HttpResponse, RequestHandler } from 'msw';

import { handlers as entityTypeSelectMenuHandlers } from '@sbu/views.entitytypeselectmenu/build/mocks';

export const insightPrimaryEntity: EntityWithRelatedEntitiesFragment = {
  __typename: 'EntityInterface',
  entityType: '_hostname',
  entityTypeName: 'Hostname',
  id: 'a',
  relatedEntities: [
    {
      __typename: 'EntityInterface',
      entityType: '_hostname',
      entityTypeName: 'Hostname',
      id: 'a1',
      reputation: 'Malicious',
      value: 'a1',
    },
    {
      __typename: 'EntityInterface',
      entityType: '_hostname',
      entityTypeName: 'Hostname',
      id: 'a2',
      reputation: 'Malicious',
      value: 'a2',
    },
    {
      __typename: 'EntityInterface',
      entityType: '_hostname',
      entityTypeName: 'Hostname',
      id: 'a3',
      reputation: 'Malicious',
      value: 'a3',
    },
  ],
  reputation: null,
  value: 'a',
};

export const insightInvolvedEntities: Array<EntityWithRelatedEntitiesFragment> =
  [
    {
      __typename: 'EntityInterface',
      entityType: '_hostname',
      entityTypeName: 'Hostname',
      id: 'a1',
      relatedEntities: [],
      reputation: 'Malicious',
      value: 'a1',
    },
    {
      __typename: 'EntityInterface',
      entityType: '_username',
      entityTypeName: 'Username',
      id: 'b',
      relatedEntities: [
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'b1',
          reputation: 'Suspicious',
          value: 'b1',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'b2',
          reputation: 'Suspicious',
          value: 'b2',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'b3',
          reputation: 'NotFlagged',
          value: 'b3',
        },
      ],
      reputation: 'Suspicious',
      value: 'b',
    },
    {
      __typename: 'EntityInterface',
      entityType: '_mac',
      entityTypeName: 'Username',
      id: 'c',
      relatedEntities: [],
      reputation: 'Suspicious',
      value: 'c',
    },
    {
      __typename: 'EntityInterface',
      entityType: '_mac',
      entityTypeName: 'Username',
      id: 'd',
      relatedEntities: [],
      reputation: 'Suspicious',
      value: 'd',
    },
    {
      __typename: 'EntityInterface',
      entityType: '_mac',
      entityTypeName: 'Username',
      id: 'g',
      relatedEntities: [],
      reputation: 'Suspicious',
      value: 'g',
    },
  ];

export const insightEntityActivityMockResponse: Array<InsightEntityActivity> = [
  {
    __typename: 'InsightEntityActivity',
    entityId: 'a',
    isPrimaryEntity: true,
    relatedEntityIds: ['a1', 'a2', 'a3'],
    involvedSignalIds: [],
  },
  {
    __typename: 'InsightEntityActivity',
    entityId: 'a1',
    isPrimaryEntity: false,
    relatedEntityIds: [],
    involvedSignalIds: [],
  },
  {
    __typename: 'InsightEntityActivity',
    entityId: 'b',
    isPrimaryEntity: false,
    relatedEntityIds: ['b1', 'b2', 'b3'],
    involvedSignalIds: [],
  },
  {
    __typename: 'InsightEntityActivity',
    entityId: 'c',
    isPrimaryEntity: false,
    relatedEntityIds: [],
    involvedSignalIds: [],
  },
  {
    __typename: 'InsightEntityActivity',
    entityId: '"custom"',
    isPrimaryEntity: false,
    relatedEntityIds: [],
    involvedSignalIds: [],
  },
  {
    __typename: 'InsightEntityActivity',
    entityId: 'd',
    isPrimaryEntity: false,
    relatedEntityIds: [],
    involvedSignalIds: [],
  },
  {
    __typename: 'InsightEntityActivity',
    entityId: 'g',
    isPrimaryEntity: false,
    relatedEntityIds: [],
    involvedSignalIds: [],
  },
];

export const handlers: RequestHandler[] = [
  ...entityTypeSelectMenuHandlers,
  http.get(
    'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.4/flags/4x3/dolorem.svg',
    () => {
      return HttpResponse.json({}, { status: 200 });
    }
  ),
  http.get('https://www.gravatar.com/avatar/:id', () => {
    return HttpResponse.json({}, { status: 200 });
  }),
  mockEntitiesDetailsQuery(async ({ query: _query, variables }) => {
    await delay(5000);
    const { entityIds } = variables;
    return HttpResponse.json({
      data: {
        __typename: 'Query',
        entitiesByListIds: getEntitiesDetails(entityIds as string[]),
      },
    });
  }),
  mockEntityRelationshipsByIdsQuery(async ({ query: _query, variables }) => {
    await delay(5000);
    const { entityIds, entityTypes } = variables;
    return HttpResponse.json({
      data: {
        __typename: 'Query',
        entitiesByListIds: getEntities(
          entityIds as string[],
          entityTypes as string[]
        ),
      },
    });
  }),
];

export const getEntitiesDetails = (ids: string[] = []) => {
  const entities: { [key: string]: InsightEntityFragment } = {
    a: {
      __typename: 'EntityInterface',
      entityType: '_hostname',
      entityTypeName: 'Hostname',
      id: 'a',
      reputation: null,
      value: 'a',
    },
    a1: {
      __typename: 'EntityInterface',
      entityType: '_hostname',
      entityTypeName: 'Hostname',
      id: 'a1',
      reputation: 'Malicious',
      value: 'a1',
    },
    a2: {
      __typename: 'EntityInterface',
      entityType: '_hostname',
      entityTypeName: 'Hostname',
      id: 'a2',
      reputation: 'Malicious',
      value: 'a2',
    },
    a3: {
      __typename: 'EntityInterface',
      entityType: '_hostname',
      entityTypeName: 'Hostname',
      id: 'a3',
      reputation: 'Malicious',
      value: 'a3',
    },
    b: {
      __typename: 'EntityInterface',
      entityType: '_username',
      entityTypeName: 'Username',
      id: 'b',
      reputation: 'Suspicious',
      value: 'b',
    },
    b1: {
      __typename: 'EntityInterface',
      entityType: '_username',
      entityTypeName: 'Username',
      id: 'b1',
      reputation: 'Suspicious',
      value: 'b1',
    },
    b2: {
      __typename: 'EntityInterface',
      entityType: '_username',
      entityTypeName: 'Username',
      id: 'b2',
      reputation: 'Suspicious',
      value: 'b2',
    },
    b3: {
      __typename: 'EntityInterface',
      entityType: '_username',
      entityTypeName: 'Username',
      id: 'b3',
      reputation: 'NotFlagged',
      value: 'b3',
    },
    c: {
      __typename: 'EntityInterface',
      entityType: '_mac',
      entityTypeName: 'Username',
      id: 'c',
      reputation: 'Suspicious',
      value: 'c',
    },
    '"custom"': {
      __typename: 'EntityInterface',
      entityType: '_mac',
      entityTypeName: 'Username',
      id: '"custom"',
      reputation: 'Suspicious',
      value: '"custom"',
    },
    d: {
      __typename: 'EntityInterface',
      entityType: '_mac',
      entityTypeName: 'Username',
      id: 'd',
      reputation: 'Suspicious',
      value: 'd',
    },
    g: {
      __typename: 'EntityInterface',
      entityType: '_mac',
      entityTypeName: 'Username',
      id: 'g',
      reputation: 'Suspicious',
      value: 'g',
    },
  };

  const filteredEntities: InsightEntityFragment[] = [];
  ids.forEach((id) => {
    const entity = entities[id];
    if (entity) {
      filteredEntities.push(entity);
    }
  });

  return filteredEntities;
};

export const getEntities = (ids: string[] = [], entityTypes: string[] = []) => {
  const entities: { [key: string]: InsightEntityWithRelationsFragment } = {
    b: {
      id: 'b',
      __typename: 'EntityInterface',
      relatedEntities: [
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'b1',
          reputation: 'Suspicious',
          value: 'b1',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'b2',
          reputation: 'Suspicious',
          value: 'b2',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'b3',
          reputation: 'NotFlagged',
          value: 'b3',
        },
      ],
      involvedEntities: [
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'p',
          reputation: 'Suspicious',
          value: 'p',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'f',
          reputation: 'Suspicious',
          value: 'f',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 's',
          reputation: 'Suspicious',
          value: 's',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'e',
          reputation: 'Suspicious',
          value: 'e',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'c',
          reputation: 'Suspicious',
          value: 'c',
        },
      ],
    },
    c: {
      id: 'c',
      __typename: 'EntityInterface',
      relatedEntities: [],
      involvedEntities: [
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'e',
          reputation: 'Suspicious',
          value: 'e',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'l',
          reputation: 'Suspicious',
          value: 'l',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'k',
          reputation: 'Suspicious',
          value: 'k',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'g',
          reputation: 'Suspicious',
          value: 'g',
        },
      ],
    },
    '"custom"': {
      id: '"custom"',
      __typename: 'EntityInterface',
      relatedEntities: [],
      involvedEntities: [
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'e',
          reputation: 'Suspicious',
          value: 'e',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'l',
          reputation: 'Suspicious',
          value: 'l',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'k',
          reputation: 'Suspicious',
          value: 'k',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'g',
          reputation: 'Suspicious',
          value: 'g',
        },
      ],
    },
    g: {
      id: 'g',
      __typename: 'EntityInterface',
      relatedEntities: [],
      involvedEntities: [
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'c',
          reputation: 'Suspicious',
          value: 'c',
        },
      ],
    },
    e: {
      id: 'e',
      __typename: 'EntityInterface',
      relatedEntities: [],
      involvedEntities: [
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'i',
          reputation: 'Suspicious',
          value: 'i',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'b',
          reputation: 'Suspicious',
          value: 'b',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'c',
          reputation: 'Suspicious',
          value: 'c',
        },
      ],
    },
    p: {
      id: 'p',
      __typename: 'EntityInterface',
      relatedEntities: [],
      involvedEntities: [
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'm',
          reputation: 'Suspicious',
          value: 'm',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'q',
          reputation: 'Suspicious',
          value: 'q',
        },
      ],
    },
    i: {
      id: 'i',
      __typename: 'EntityInterface',
      relatedEntities: [],
      involvedEntities: [
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'e',
          reputation: 'Suspicious',
          value: 'e',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 's',
          reputation: 'Suspicious',
          value: 's',
        },
      ],
    },
    s: {
      id: 's',
      __typename: 'EntityInterface',
      relatedEntities: [],
      involvedEntities: [
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'b',
          reputation: 'Suspicious',
          value: 'b',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_username',
          entityTypeName: 'Username',
          id: 'i',
          reputation: 'Suspicious',
          value: 'i',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_command',
          entityTypeName: 'Command',
          id: 'v',
          reputation: 'Suspicious',
          value: 'v',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_file',
          entityTypeName: 'File',
          id: 'x',
          reputation: 'Suspicious',
          value: 'x',
        },
        {
          __typename: 'EntityInterface',
          entityType: '_url',
          entityTypeName: 'Url',
          id: 'z',
          reputation: 'Suspicious',
          value: 'z',
        },
      ],
    },
  };

  const filteredEntities: InsightEntityWithRelationsFragment[] = [];
  ids.forEach((id) => {
    const entity = entities[id];
    if (entity) {
      filteredEntities.push({
        ...entity,
        relatedEntities: entity.relatedEntities.filter(
          ({ entityType }) =>
            entityTypes.length === 0 || entityTypes.indexOf(entityType) !== -1
        ),
        involvedEntities: entity.involvedEntities.filter(
          ({ entityType }) =>
            entityTypes.length === 0 || entityTypes.indexOf(entityType) !== -1
        ),
      });
    }
  });

  return filteredEntities;
};
